// extracted by mini-css-extract-plugin
module.exports = {"authorization":"authorization_authorization__3JnfI","buttonGroup":"authorization_buttonGroup__M_fq9","cancel":"authorization_cancel__38kvL"};